<template>
  <iframe
    v-if="notifierUrl"
    ref="iframeRef"
    :src="notifierUrl"
    style="display: none; width: 0; height: 0; border: none"
    title="Notifier Worker"
    @load="sendCredentials"
  />
</template>

<script setup lang="ts">
import {computed, onMounted, onUnmounted, ref, watch} from 'vue';

import settings from '@/config/settings';

import {keycloakAPI} from '@/assets/keycloak';

const iframeRef = ref<HTMLIFrameElement | null>(null);

const notifierUrl = computed(() => {
  const url = settings.SERVICES.NOTIFIER?.URL;
  if (!url) return null;
  return url + '/notification-api-sub';
});

const notifierOrigin = computed(() => settings.SERVICES.NOTIFIER?.URL);

const sendCredentials = () => {
  if (!iframeRef.value?.contentWindow || !notifierOrigin.value) return;

  const targetOrigin = notifierOrigin.value;

  if (keycloakAPI.getToken.value) {
    iframeRef.value.contentWindow.postMessage(
      {type: 'UPDATE_TOKEN', token: keycloakAPI.getToken.value},
      targetOrigin,
    );
  }

  const plainUserInfo = JSON.parse(
    JSON.stringify(keycloakAPI.getUserInfo.value),
  );
  iframeRef.value.contentWindow.postMessage(
    {type: 'UPDATE_USER_INFO', userInfo: plainUserInfo},
    targetOrigin,
  );

  iframeRef.value.contentWindow.postMessage(
    {type: 'AUTH_CHANGE', isAuthenticated: keycloakAPI.getIsLoggedIn.value},
    targetOrigin,
  );
};

watch([keycloakAPI.getToken, keycloakAPI.getIsLoggedIn], () => {
  sendCredentials();
});

onMounted(() => {
  if (notifierUrl.value) {
    window.addEventListener('message', handleMessage);
  }
});

onUnmounted(() => {
  window.removeEventListener('message', handleMessage);
});

const handleMessage = (event: MessageEvent) => {
  const message = event.data;
  if (!message) return;

  if (message.type === 'NEW_NOTIFICATIONS') {
    console.log('New notifications received', message);
  }
};
</script>

<style lang="scss" />
